import Model from '@/models/Model.js';

export default class EbookActivity extends Model {
    static entity = 'ebook_activity';
    static modelName = 'EbookActivity';

    static fields() {
        return {
            id: this.attr(null),
        };
    }
}
